import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { LocationUpdatePayload } from "../../utils/location.types";

const BASE = "/api/v1/erp/locations";

// List locations for the logged-in account (account derived from token server-side).
export const fetchLocations = createAsyncThunk(
  "location/fetchLocations",
  async (params?: string): Promise<any> => {
    const query = params ? `?${params}` : "";
    const response = await axios.get(`${BASE}${query}`);
    return response.data; // array of locations
  }
);

export const fetchLocationById = createAsyncThunk(
  "location/fetchLocationById",
  async (id: string): Promise<any> => {
    const response = await axios.get(`${BASE}/${id}`);
    return response.data;
  }
);

export const addLocation = createAsyncThunk(
  "location/addLocation",
  async (locationPayload: any): Promise<any> => {
    const response = await axios.post(BASE, locationPayload);
    return response.data;
  }
);

export const updateLocation = createAsyncThunk(
  "location/updateLocation",
  async ({ id, locationPayload }: LocationUpdatePayload): Promise<any> => {
    const response = await axios.put(`${BASE}/${id}`, locationPayload);
    return response.data;
  }
);
